import { useCallback, useEffect } from 'react';
import { COMPONENT_HEIGHT, CONTAINER_HEIGHT } from './subcomponents';
/** Listens for click outside of Select dropdown */
export const useOutsideAlerter = (ref, callback) => {
    const handleClickOutside = (event) => {
        /**
         * If component is used in shadow dom, all events will retargeted to shadow root.
         * So the value of event.target will always be shadow root.
         * Instead use event.path to verify the origin of event
         */
        var _a, _b, _c;
        const originalTarget = event.target.shadowRoot
            ? ((_a = event.path) === null || _a === void 0 ? void 0 : _a[0]) || ((_c = (_b = event.composedPath) === null || _b === void 0 ? void 0 : _b.call(event)) === null || _c === void 0 ? void 0 : _c[0])
            : event.target;
        if (ref.current && !ref.current.contains(originalTarget)) {
            callback();
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
};
export const dispatchEvent = (nativeSelectRef, shouldChangeBeDispatched) => {
    let event;
    if (typeof Event === 'function') {
        event = new Event('change', { bubbles: true });
    }
    else {
        event = document.createEvent('Event');
        event.initEvent('change', true, false);
    }
    // end ie compatibility
    if (shouldChangeBeDispatched) {
        nativeSelectRef.current.dispatchEvent(event);
    }
};
export const useUpdateMenuPosition = (options, setMenuPosition, isMenuOpen, autoAdjust) => {
    return useCallback((node) => {
        if (!!node && autoAdjust) {
            // get the rect of the current Select field
            const rect = node.getBoundingClientRect();
            // calculate the position offset Y of the current Select field
            const fieldOffsetY = rect.top + rect.height;
            // measure the actual length of the menu container based on number of option
            const actualLength = options.length * COMPONENT_HEIGHT;
            // compare if actual length is < container max height (275)
            const menuContainerHeight = actualLength < CONTAINER_HEIGHT ? actualLength : CONTAINER_HEIGHT;
            // calculate the bottom space between the field and window
            const bottomSpace = window.innerHeight - fieldOffsetY;
            // set placement TOP if bottom space is less than menu container height
            setMenuPosition(bottomSpace < menuContainerHeight ? 'TOP' : 'BOTTOM');
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isMenuOpen]);
};
export const isOptionEqual = (firstOption, secondOption) => {
    return ((firstOption === null || firstOption === void 0 ? void 0 : firstOption.value) === (secondOption === null || secondOption === void 0 ? void 0 : secondOption.value) &&
        (firstOption === null || firstOption === void 0 ? void 0 : firstOption.label) === (secondOption === null || secondOption === void 0 ? void 0 : secondOption.label));
};
//# sourceMappingURL=helpers.js.map